import { DateTimeField } from '@mews-commander/form';
import { lt, useFeatureFlag, useTodayAsStructuredDate } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { PaymentRequestFormField } from '../schema';

export const PaymentRequestFormExpirationField = () => {
    const isPaymentRequestCollectTypeEnabled = useFeatureFlag(FeatureFlag.paymentRequestCollectTypeEnabled);
    const today = useTodayAsStructuredDate();

    return (
        <DateTimeField
            name={PaymentRequestFormField.ExpirationUtc}
            label={lt(
                isPaymentRequestCollectTypeEnabled
                    ? 'ProcessPaymentPaymentRequestExpirationLabel'
                    : 'ProcessPaymentMewsPaymentsPaymentLinkExpirationDateTitle'
            )}
            required
            dateProps={{ minDate: today }}
        />
    );
};
